import { StatusType } from '@spotify/confidence-core-react';
import { MetricsV1MetricState } from '@spotify/confidence-graphql';

type MetricStateDisplay = {
  label: string;
  status: StatusType;
};

const METRIC_STATE_DISPLAY: Record<MetricsV1MetricState, MetricStateDisplay> = {
  [MetricsV1MetricState.Draft]: {
    label: 'Draft',
    status: StatusType.PENDING,
  },
  [MetricsV1MetricState.Active]: {
    label: 'Active',
    status: StatusType.OK,
  },
  [MetricsV1MetricState.Archived]: {
    label: 'Archived',
    status: StatusType.ABORTED,
  },
  [MetricsV1MetricState.Deleted]: {
    label: 'Deleted',
    status: StatusType.ERROR,
  },
};

export const getMetricStateDisplay = (
  state: MetricsV1MetricState,
): MetricStateDisplay => METRIC_STATE_DISPLAY[state];
